import { createSlice, configureStore } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name:"user",
    initialState: {
        user: null,
        isLogin: false,
        token: null
    },
    reducers: {
        login(state, action) {
            localStorage.setItem('token',action.payload.token);
            // localStorage.setItem('user', JSON.stringify(action.payload.user));
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isLogin = true;
        },
        updateProfile(state, action) {
            let user = state.user;
            if(action.payload.userName) {
                user.userName = action.payload.userName;
            }
            if (action.payload.phone) {
                user.phone = action.payload.phone;
            }
            if (action.payload.country) {
                user.country = action.payload.country;
            }
            if (action.payload.companies) {
                user.companies = action.payload.companies;
            }
            state.user = user;
        },
        logout(state) {
            localStorage.removeItem('token');
            state.user = null;
            state.token = null;
            state.isLogin = null;
        }
    }
});

export const { login, logout, updateProfile } = userSlice.actions;
export const userStore = configureStore({
   reducer: userSlice.reducer 
});